/* ===========================================================================
 * BACK BUTTON FIX + DIAGNÓSTICO
 * ---------------------------------------------------------------------------
 * PARTE 1 — CORREÇÃO
 *   Links com href="#" (ou terminados em "#") fazem o navegador navegar para
 *   um fragmento vazio. Isso ADICIONA uma entrada no histórico. O usuário
 *   clica em "voltar", o navegador só remove o "#", a página não muda e
 *   parece que o botão voltar está travado.
 *
 *   Este script cancela apenas a navegação padrão desses links. Qualquer
 *   listener de clique (do tema ou de app) continua funcionando normalmente,
 *   porque preventDefault() não impede outros handlers de rodar.
 *
 * PARTE 2 — DIAGNÓSTICO (desligado por padrão)
 *   Se a URL tiver ?debugback=1, um painel preto aparece no canto da tela
 *   mostrando, em tempo real, tudo que mexe no histórico do navegador e qual
 *   arquivo fez isso. Serve para identificar apps/pixels que estão empilhando
 *   entradas. Não afeta visitantes normais.
 * ========================================================================= */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     PARTE 1 — corrigir links de fragmento vazio
     ---------------------------------------------------------------------- */
  function isEmptyHashLink(anchor) {
    var raw = anchor.getAttribute('href');
    if (!raw) return false;
    /* Só "#" ou uma URL terminada em "#" sem nada depois. Âncoras reais
       como "#reviews" ou "/produtos#tabs" NÃO entram aqui. */
    return raw === '#' || /#$/.test(raw);
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest
      ? event.target.closest('a')
      : null;

    if (!anchor) return;
    if (!isEmptyHashLink(anchor)) return;

    /* Cancela só a navegação. Os handlers do tema/app seguem rodando. */
    event.preventDefault();
  }, false); /* fase de bolha: roda depois dos handlers do tema */

  /* ----------------------------------------------------------------------
     PARTE 2 — painel de diagnóstico (?debugback=1)
     ---------------------------------------------------------------------- */
  if (window.location.search.indexOf('debugback=1') === -1) return;

  var panel = document.createElement('div');
  panel.setAttribute('style', [
    'position:fixed', 'z-index:2147483647', 'bottom:0', 'left:0', 'right:0',
    'max-height:45vh', 'overflow:auto', 'background:#000', 'color:#0f0',
    'font:11px/1.45 monospace', 'padding:10px 12px 40px',
    'border-top:2px solid #0f0', 'white-space:pre-wrap', 'word-break:break-all'
  ].join(';'));

  var closeBtn = document.createElement('button');
  closeBtn.textContent = 'FECHAR';
  closeBtn.setAttribute('style', [
    'position:fixed', 'z-index:2147483647', 'bottom:8px', 'right:12px',
    'background:#0f0', 'color:#000', 'border:0', 'padding:6px 14px',
    'font:11px monospace', 'font-weight:bold', 'cursor:pointer'
  ].join(';'));
  closeBtn.addEventListener('click', function () {
    panel.remove();
    closeBtn.remove();
  });

  var lineCount = 0;

  function log(text) {
    lineCount++;
    var line = document.createElement('div');
    line.textContent = lineCount + '. ' + text;
    line.style.borderBottom = '1px solid #062';
    line.style.padding = '3px 0';
    panel.appendChild(line);
    panel.scrollTop = panel.scrollHeight;
  }

  /* Descobre qual arquivo chamou a função, lendo a pilha de execução. */
  function callerFile() {
    try {
      var stack = new Error().stack || '';
      var lines = stack.split('\n');
      for (var i = 0; i < lines.length; i++) {
        var text = lines[i];
        if (text.indexOf('back-button-fix') !== -1) continue;
        var match = text.match(/(https?:\/\/[^\s)]+)/);
        if (match) return match[1];
      }
    } catch (e) { /* noop */ }
    return 'origem desconhecida';
  }

  function attach() {
    document.body.appendChild(panel);
    document.body.appendChild(closeBtn);

    log('DIAGNOSTICO ATIVO');
    log('entradas no historico agora: ' + history.length);

    var originalPush = history.pushState;
    var originalReplace = history.replaceState;

    history.pushState = function () {
      log('>>> pushState (CRIA entrada nova)  total=' + (history.length + 1));
      log('    quem chamou: ' + callerFile());
      return originalPush.apply(this, arguments);
    };

    history.replaceState = function () {
      log('replaceState (nao cria entrada)');
      log('    quem chamou: ' + callerFile());
      return originalReplace.apply(this, arguments);
    };

    window.addEventListener('hashchange', function () {
      log('!!! hashchange — a URL ganhou/perdeu um "#"  total=' + history.length);
    });

    window.addEventListener('popstate', function () {
      log('popstate — o voltar foi acionado  total=' + history.length);
    });

    /* Vigia crescimento espontâneo do histórico. */
    var last = history.length;
    setInterval(function () {
      if (history.length !== last) {
        log('### historico mudou sozinho: ' + last + ' -> ' + history.length);
        last = history.length;
      }
    }, 1000);
  }

  if (document.body) {
    attach();
  } else {
    document.addEventListener('DOMContentLoaded', attach);
  }
})();
